import { useParams, useOutletContext } from 'react-router-dom'
import useUserEvents from '../../hooks/useUserEvents'
import UserEventsSection from '../../components/UserProfile/UserEventsSection'
import UserInfoSection from '../../components/UserProfile/UserInfoSection'
import SpinnerCircular from '../../components/SpinnerCircular'
import { theme } from '../../theme'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import styled from 'styled-components'
import Typography from '../../components/Typography'
import { useTranslation } from 'react-i18next'

export default function UserEvents() {
  const { userId } = useParams();
  const { profileUser, isOwnProfile } = useOutletContext()
  const { futureEvents, attendeeEvents, loadingEvents } = useUserEvents(userId)
  const { width } = useWindowDimensions();
  const isTablet = width < parseInt(theme.breakpoints.lg);
  const { t: tCommon } = useTranslation('common');

  if (loadingEvents) {
    return (
      <LoadingContainer>
        <SpinnerCircular
          size={30}
          thickness={180}
          speed={100}
          color={theme.fill.brandMain}
          secondaryColor={theme.fill.defaultWeak}
        />
        <Typography as="h3" $variant="body-1-semibold" color={theme.colors.defaultWeak}>
          {tCommon('loadingEvents')}
        </Typography>
      </LoadingContainer>
    )
  }

  return (
    <EventsPage>
      <Container>
        <Grid>
          {!isTablet && (
            <UserInfoSection
              profileUser={profileUser}
              userId={userId}
              isOwnProfile={isOwnProfile}
            />
          )}
          <UserEventsSection
            futureEvents={futureEvents}
            attendeeEvents={attendeeEvents}
            isOwnProfile={isOwnProfile}
          />
        </Grid>
      </Container>
    </EventsPage>
  );
};

const EventsPage = styled.section`
  align-items: center;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.md};
  max-width: 1400px;
  padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.md};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.sm};
  }
`;

const Grid = styled.div`
  display: grid;
  gap: 0 ${({ theme }) => theme.sizing.lg};
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 1fr;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    flex-direction: column;
  }
`;

const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.sizing.xl} ${({ theme }) => theme.sizing.md};
`;